export enum ELoaiTaiKhoan {
  AdminTong = 0,
  ThongThuong = 1,
}

export enum EGioiTinh {
  Nam = 1,
  Nu = 2,
  Khac = 3,
}

export enum ETinhTrangHonNhan {
  DocThan = 0,
  DaKetHonChuaCon = 1,
  DaKetHonMotCon = 2,
  DaKetHonHaiCon = 3,
}

export enum ELoaiHinhNhanVien {
  ThucTap = 1,
  CTV = 2,
  ThuViec = 3,
  ChinhThuc = 4,
}

export enum ETrangThaiNhanVien {
  DaNghiViec = 0,
  DangLamViec = 1,
  HoanLamViec = 2,
}

export enum ELoaiKhenThuongKyLuat {
  KyLuat = 0,
  KhenThuong = 1,
}
export enum ELoaiHopDong {
  HopDongHopTac = 1,
  HopDongLaoDong = 2,
}

export enum EBucketName {
  PUBLIC = 'public',
  PRIVATE = 'private',
}

export enum ELoaiCheDo {
  CheDoPhucLoi = 1,
  CheDoLamViec = 2,
}

export enum ETrangThaiDonXinNghi {
  Huy = 0,
  DangLap = 1,
  ChoDuyet = 2,
  DaDuyet = 3,
}

export enum ELoaiTinTuc {
  ThongBao = 1,
  VanBan = 2,
}

export enum ETrangThaiTinTuc {
  DangLap = 1,
  ChoPheDuyet = 2,
  DaPhatHanh = 3,
}

export enum ETrangThaiKraMau {
  NgungApDung = 0,
  DangApDung = 1,
}

export enum ELoaiKra {
  ChuyenMon = 1,
  PhoiHopPhongBan = 2,
  PhatTrienBanThan = 3,
}

export enum ETrangThaiKraThang {
  DangThucHien = 1,
  ChoDuyet = 2,
  DaDuyet = 3,
}

export enum ETrangThaiKraThangChiTiet {
  DangLam = 1,
  HoanThanh = 2,
}

export enum ETrangThaiBaoCaoTuan {
  ChuaLam = 1,
  DangLam = 2,
  HoanThanh = 3,
  HoanThanhMucTieu = 4,
  KhongPhaiMucTieu = 5,
}

export enum EKetQuaKra {
  ChuaHoanThanh = 0,
  HoanThanh = 1,
}

export enum ETrangThaiKrMucTieu {
  DangThucHien = 1,
  DaHuy = 2,
}

export enum ELoaiKrMucTieu {
  Quy = 1,
  Thang = 2,
}

export enum ETrangThaiKrCongViec {
  DangLap = 1,
  DangThucHien = 2,
  HoanThanh = 3,
  DaHuy = 4,
}

/** Trạng thái phỏng vấn trên hồ sơ ứng viên */
export enum ETrangThaiPhongVan {
  ChoXepLich = 1,
  DaHen = 2,
  Delay = 3,
  Pass = 4,
  KhongPass = 5,
  KhongDen = 6,
}

/** Trạng thái đào tạo trên hồ sơ ứng viên. null = chưa tới bước */
export enum ETrangThaiDaoTao {
  ChoXepLop = 1,
  DangDaoTao = 2,
  Delay = 3,
  HoanThanh = 4,
  KhongHoc = 5,
}

/** Trạng thái nhận việc trên hồ sơ ứng viên. null = chưa tới bước */
export enum ETrangThaiNhanViecUngVien {
  ChoHen = 1,
  DaHen = 2,
  Delay = 3,
  DaHoc = 4,
  KhongHoc = 5,
}

export enum EKetQuaPhongVan {
  Pass = 1,
  KhongPass = 2,
  Delay = 3,
  KhongDen = 4,
}

export enum EKetQuaDaoTao {
  DaHoc = 1,
  KhongHoc = 2,
  Delay = 3,
}
